<template>
  <div id="app">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;800&display=swap" rel="stylesheet">
    <Game />
  </div>
</template>

<script>
import Game from './components/Game.vue'

export default {
  name: 'App',
  components: {
    Game
  }
}
</script>

<style>
  body, #app {
    margin: 0;
    padding: 0;
    /*background: #000;*/
    background: rgb(255,253,232);
background: linear-gradient(180deg, rgba(255,253,232,1) 0%, rgba(255,253,232,1) 50%, rgba(151,187,202,1) 50%, rgba(151,187,202,1) 100%);
    position: relative;
    font-family: 'Open Sans', sans-serif;
    min-height: 1000px; /*100vh;*/
    /*font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;*/
  }
  @media screen and (max-width:  1000px) {
    html, body, #app {
      min-height: 100vh;
      height: 100%
    }
  }
</style>
